import { CompatibleTableStructure } from './CompatibilityTable.js';
import { CompatibilityTableFactory } from './CompatibilityTableFactory.js';
import { TypeReference } from '../types.js';
import { Model } from '../engine.js';


export class CompatibilityTableParser {
  private type: TypeReference;
  private name: string;
  private structure: CompatibleTableStructure;
  private data: (string[] | boolean[] | number[])[] = [];
  private whenExpression: (model: Model) => boolean;

  constructor(private doc: unknown) {
  }

  parse(): CompatibilityTableFactory {
    this.parseName(this.doc);
    this.parseType(this.doc);
    this.parseStructure(this.doc);
    this.parseData(this.doc);
    this.parseWhenExpression(this.doc);
    return new CompatibilityTableFactory(this.name, this.type, this.structure, this.data, this.whenExpression);
  }

  private parseName(doc: any) {
    if ('_id' in doc) {
      this.name = doc._id;
    } else {
      throw new TypeError(`CompatibilityTable. Missing '_id' field`);
    }
  }

  private parseType(doc: any) {
    if ('type' in doc && typeof doc.type === 'string') {
      this.type = doc.type;
    } else {
      throw new TypeError(`CompatibilityTable ${this.name}. Missing 'type' field`);
    }
  }

  private parseData(doc: any) {
    if ('data' in doc && Array.isArray(doc.data)) {
      for (let row of doc.data) {
        this.parseRow(row);
      }
    } else {
      throw new TypeError(`CompatibilityTable ${this.name}. Field 'data' should be a list of rules`)
    }
  }

  private parseRow(row: any) {
    if (Array.isArray(row) && row.length === this.structure.columns.length) {
      this.data.push(row);
    } else {
      throw new TypeError(`CompatibilityTable ${this.name}. Rule should be a list of ${this.structure.columns.length} elements`);
    }
  }

  private parseStructure(doc: any) {
    if ('order' in doc) {
      if (Array.isArray(doc.order)) {
        this.structure = {
          columns: doc.order.map(String)
        };
      } else {
        throw new TypeError(`CompatibilityTable ${this.name}. Field 'order' should be a list of property names`);
      }
    } else {
      throw new TypeError(`CompatibilityTable ${this.name}. Field 'order' is missing`)
    }
  }

  private parseWhenExpression(doc: any) {
    if ('when' in doc) {
      const func = new Function('root, data', doc.when) as (model: Model, data: (string[] | boolean[] | number[])[]) => boolean;
      this.whenExpression = (model: Model) => func(model, this.data);
    } else {
      this.whenExpression = () => true;
    }
  }
}
